import React from "react";
import { CertifierSummaryCardsTemplate } from "themes/application/certifier/components";
import { observer } from "mobx-react";

const CertifierSummaryCards = observer(function CertifierSummaryCards(props) {
    return <CertifierSummaryCardsTemplate {...props} />;
});

export default CertifierSummaryCards;
